import React, { useCallback } from "react";

import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import Menu from "antd/es/menu";
import { MenuInfo } from "rc-menu/lib/interface";
import { useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import useCalendarView from "@app/component/view/CalendarView/utils/useCalendarView";
import CalendarViewMode, {
  AllCalendarViewModes,
  getCalendarViewModeDisplayName,
} from "@app/enum/CalendarViewMode";
import { smartPlannerViewAnalytics } from "@app/scene/activity/activityTableAnalytics";

interface Props {}

const ViewModeButton: React.FC<Props> = () => {
  const intl = useIntl();
  const { changeViewMode, viewState } = useCalendarView<Activity>();

  const handleViewModeClick = ({ key }: MenuInfo) => changeViewMode(key as CalendarViewMode);

  const handleClick = useCallback(() => {
    smartPlannerViewAnalytics.clicked(["Calendar Timeframe Dropdown"]);
  }, []);

  return (
    <Dropdown
      overlay={
        <Menu onClick={handleViewModeClick}>
          {AllCalendarViewModes.map((mode) => (
            <Menu.Item key={mode}>{getCalendarViewModeDisplayName(intl, mode)}</Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button
        onClick={handleClick}
        rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
        type="text"
      >
        {getCalendarViewModeDisplayName(intl, viewState.viewMode)}
      </Button>
    </Dropdown>
  );
};

export default ViewModeButton;
